import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';

export const AgenticCommerceSettingsConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "agenticCommerceSettings" */ '../../../components/AgenticCommerceSettings/AgenticCommerceSettings'
    ),
  enabledKey: 'agentic_commerce_settings',
  htmlEvents: [],
  releaseState: 'internal',
  sentryTeam: 'connect_marketplaces',
  teamOwner: 'connect-integrations',
  description:
    'Displays settings to manage agentic commerce, including a buttons to enable/disable orchestrated commerce agreements (OCAs) with AI agents.',
  friendlyName: 'Agentic commerce settings',
};
